import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Expenses from './pages/Expenses';
import Employees from './pages/Employees';
import Salaries from './pages/Salaries';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Profile from './pages/Profile';
import Attendance from './pages/Attendance';
import Billing from './pages/Billing';
import PhoneBook from './pages/PhoneBook';
import './styles/index.css';
import { Analytics } from "@vercel/analytics/react";


// Layout component for protected routes
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Navbar />
      <Outlet />
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Protected routes with navbar */}
            <Route element={<ProtectedLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/events" element={<Events />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/salaries" element={<Salaries />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/users" element={<Users />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/phone-book" element={<PhoneBook />} />
            </Route>

            {/* Redirect root to dashboard if authenticated, login otherwise */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Analytics />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
